import { InjectionToken } from '@angular/core';

export const DISCOVERY_URL = new InjectionToken<string>('DISCOVERY_URL');



// WEBPACK FOOTER //
// ./src/app/login/auth.tokens.ts